import { z } from 'zod/v4';
import {
  ENTITY_SCREENING_ENTITY_TYPE,
  type EntityScreeningEntityType,
} from '../../constants.js';

const entityTypeValues = Object.values(ENTITY_SCREENING_ENTITY_TYPE) as [
  EntityScreeningEntityType,
  ...EntityScreeningEntityType[],
];

export const EmbeddingSchema = z.object({
  id: z.string(),
  entityId: z.string(),
  textForEmbedding: z.string(),
  modelUsed: z.string(),
  createdAt: z.date(),
  embedding: z.array(z.number()),
  updatedAt: z.date(),
  entityType: z.enum(entityTypeValues),
  composedOf: z.unknown(),
});

export type Embedding = z.infer<typeof EmbeddingSchema>;
